module.exports = __webpack_public_path__ + "img/tuhuang.18e0937f.png";